import { NgModule }                from '@angular/core';
import { FormsModule }             from '@angular/forms';
import { CommonModule }            from '@angular/common';
import { ClientCargoComponent }    from './client-cargo.component';
import { TransportCargoComponent } from './transport-cargo.component';
import { CargoService }            from './cargo.service';
import { CommonToolModule }        from '../common/common-tool.module';
import { NgxMyDatePickerModule }   from 'ngx-mydatepicker';
import { AgmCoreModule }           from '@agm/core';
import { AgmDirectionModule }      from 'agm-direction';
import { ScheduleModule }          from '../schedule/schedule.module';
import { CargoListComponent }      from './cargo-list.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgxMyDatePickerModule,
        AgmCoreModule,
        AgmDirectionModule,
        ScheduleModule,
        CommonToolModule      //共通部品をcomponentとしてimportするとエラーになる、module化してimportする
    ],
    declarations: [
        ClientCargoComponent,
        TransportCargoComponent,
        CargoListComponent
    ],
    providers: [  ]
})
export class CargoModule {}



// WEBPACK FOOTER //
// ./src/app/cargo/cargo.module.ts